export const PREFIXES = {
  male: ["Mr.", "Mrs.", "Dr."],
  female: ["Ms.", "Miss"],
};
